<template>
	<div class="login">
		<div class="navigation">
			<el-image class="logo-img" :src="require('@/assets/img/logo.png')" fit="contain" />
		</div>
		<div class="content">
			<div class="title">登录</div>
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="login-ruleForm" size="large" status-icon>
				<el-form-item label="" prop="phone">
					<el-input v-model="ruleForm.phone" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号" />
				</el-form-item>
				<el-form-item label="" prop="password">
					<el-input v-model="ruleForm.password" type="password" prefix-icon="el-icon-lock"
						placeholder="请输入密码" />
				</el-form-item>
				<el-form-item>
					<el-button class="main-btn" type="primary" @click="submitForm('ruleForm')">登录</el-button>
				</el-form-item>
			</el-form>
			<div class="link">
				<router-link to="/register"><span>立即注册</span></router-link>
				<!-- <router-link to="/forgotPassword"><span>忘记密码</span></router-link> -->
			</div>
		</div>

		<div class="footer">
			<span>玉韦耶克物联有限公司版权所有</span>
			<span>全国服务热线：400-6767-225</span>
			<span>www.yuweiyeke.com</span>
		</div>
	</div>
</template>

<script>
	import http from "../http.js";
	export default {
		data() {
			return {
				ruleForm: {
					phone: "",
					password: "",
				},
				rules: {
					phone: [{
							required: true,
							message: "请输入手机号",
							trigger: "blur"
						},
						{
							pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
							message: "请输入正确的手机号",
							trigger: "blur",
						},
					],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}],
				}
			}
		},
    created() {
      // get query
      console.log(this.$route.query);
      let query = this.$route.query;
      if (query && query.from === 'sso' && query.token) {
        localStorage.setItem("token", query.token);
        this.getInfo()
      }
    },
    methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						http.fetchPost("/api/user/login", {
							type: 1,
							phone: this.ruleForm.phone,
							password: this.ruleForm.password,
						}).then((res) => {
							if (res.data.code == 0) {
								localStorage.setItem("token", res.data.data.token);
								localStorage.setItem("name", res.data.data.name);
								localStorage.setItem("phone", res.data.data.phone);
								this.token = res.data.data.token;
								this.userName = res.data.data.name;
								// this.getInfo();
								this.$message.success("登录成功");
								this.$router.push('/home')
							} else {
								if (this.ruleForm.phone == 'test') {
									this.$message.error('测试账号已过期')
								} else {
									this.$message.error(res.data.desc);
								}
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getInfo() {
				http.fetchGet("/api/user/info").then((res) => {
					console.log('getInfo')
					if (res.data.code == 0) {
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("phone", res.data.data.phone);
            this.$router.push('/home')
					}
				});
			},
		}
	}
</script>

<style lang="scss">
	//scss
</style>
